export default __webpack_public_path__ + "static/analytics2-f3eb99d92eed66256c2fb0a8cd2b168c.png";